import React, { Component } from 'react';
import { connect } from "react-redux";
import { Link, Redirect, withRouter } from "react-router-dom";
import { debounce } from "lodash";

import { LoadingIcon } from '../Common/Loading_Icon';

import axios from "axios";
import { OEMCarIcon, OEMMotorcycleIcon } from '../Common/Buttons/Icons';
import { Trans } from 'react-i18next';

//A React component will allow us to quickly iterate and change our code. It provides 
class EUFleets extends Component {
    constructor(props) {
        super(props);

        this.acceptInvitation = debounce(this.acceptInvitation.bind(this), 500);
        this.completeSurvey = debounce(this.completeSurvey.bind(this), 500);
        this.requestAccess = debounce(this.requestAccess.bind(this), 500);
        this.seeVehicles = debounce(this.seeVehicles.bind(this), 500);

        this.state = {
        };
    }

    acceptInvitation(e, invitaion_id) {
        var self = this;
        axios.get('/ajax/invite/' + invitaion_id)
        .then(function(response) {
            showStatusMsg(response?.data.message, "success");

            if(response?.data.redirect != undefined) {
                self.props.history.push(('/' + response?.data.redirect));
            } else if("update_fleets" in self.props) {
                self.props.update_fleets();
            }
        })
        .catch(function(error) {
            //handle error
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                self.props.history.push('/');
                showStatusMsg("Requested information not found");
            }
        })
    }

    completeSurvey(e) {
        var self = this;
        self.props.history.push(('/survey'));
    }

    requestAccess(e, stakeholder_id) {
        var self = this;
        axios.post('/ajax/invite/apply/' + stakeholder_id)
        .then(function(response) {
            showStatusMsg(response?.data.message, "success");
            if(response?.data.redirect != undefined) {
                self.props.history.push(('/' + response?.data.redirect));
            } else if("update_fleets" in self.props) {
                self.props.update_fleets();
            }
        })
        .catch(function(error) {
            //handle error
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                self.props.history.push('/');
                showStatusMsg("Requested information not found");
            }
        })
    }

    seeVehicles(e, stakeholder, division) {
        this.props.history.push("/vehicles/" + stakeholder.toLowerCase().replace(/\s/g,'') + "/" + division.toLowerCase().replace(/\s/g,''));
    }

    render() {

        // hide request access cards for now
        const shouldShowRequestAccessApplicationCard = false;

        return (
            <div className="eu-mainsection-fleets"> {/*Fleets Section*/}
                <h1 className = "eu-mainsection-title"><Trans>Fleets</Trans></h1>
                {
                    this.props.loading ?
                        <LoadingIcon />
                    :
                        <>
                            {
                                this.props.sh_list.approved.length > 0 ?
                                    <div className="eu-mainsection-fleets-category">
                                        {/*Approved Fleets*/}
                                        <h3 className = "eu-mainsection-fleets-category-title"><Trans>Approved</Trans></h3>
                                        <div className="line-break"></div>
                                        <div className="eu-mainsection-fleets-row">
                                            {
                                                this.props.sh_list.approved.map((stakeholder, index) =>
                                                    <a onClick={(e) => this.seeVehicles(e, stakeholder.Company, stakeholder.Division)} key={"approved_" + stakeholder.SH_ID} className="eu-mainsection-fleets-card" style={{cursor: "pointer"}}>
                                                        <div className="eu-mainsection-fleets-card-section" style = {{background: stakeholder.color}}>
                                                            <div className="eu-mainsection-fleets-card-section-top">
                                                                <div className="eu-mainsection-fleets-card-section-top-cars">
                                                                    <p style={{fontSize: '9pt'}}>{ stakeholder.vehicles }</p>
                                                                    {
                                                                        stakeholder.vehicle_type == "motorcycles" ?
                                                                            OEMMotorcycleIcon()
                                                                        :
                                                                            OEMCarIcon()
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div className="eu-mainsection-fleets-card-section-mid">
                                                                <img className = "eu-mainsection-fleets-card-logo" src={ stakeholder.image }/>
                                                                <p className = "eu-mainsection-fleets-card-oem">{ stakeholder.Company }</p>
                                                                <p className = "eu-mainsection-fleets-card-city">{ stakeholder.vmh_location }</p>
                                                            </div>
                                                        </div>
                                                        <div className="button primary eu-mainsection-fleets-card-cta">
                                                            <Trans>See Vehicles</Trans>
                                                        </div>
                                                    </a>
                                                )
                                            }
                                        </div>
                                    </div> 
                                :
                                    null
                            }
                            {
                                this.props.sh_list.pending.length > 0 || this.props.sh_list.invitaion.length > 0 || this.props.sh_list.survey.length > 0 || (shouldShowRequestAccessApplicationCard && this.props.sh_list.application.length > 0) ?
                                    <div className="eu-mainsection-fleets-category fleets-category-applications">
                                        {/*Application Fleets*/}
                                        <h3 className = "eu-mainsection-fleets-category-title"><Trans>Applications</Trans></h3>
                                        <div className="line-break"></div>
                                        <div className="eu-mainsection-fleets-row">
                                            {/* Pending Survey */}
                                            {
                                                this.props.sh_list.survey.length > 0 ?
                                                    this.props.sh_list.survey.map((stakeholder, index) =>
                                                        <a key={"survey_" + stakeholder.SH_ID} className="eu-mainsection-fleets-card">
                                                            <div className="eu-mainsection-fleets-card-section">
                                                                <div className="eu-mainsection-fleets-card-section-top">
                                                                    <div className="eu-mainsection-fleets-card-section-top-cars">
                                                                        <p className = 'primary'><Trans>Survey Pending</Trans></p>
                                                                    </div>
                                                                </div>
                                                                <div className="eu-mainsection-fleets-card-section-mid">
                                                                    <img className = "eu-mainsection-fleets-card-logo" src={ stakeholder.image }/>
                                                                    <p className = "eu-mainsection-fleets-card-oem">{ stakeholder.Company }</p>
                                                                    <p className = "eu-mainsection-fleets-card-city">{ stakeholder.vmh_location }</p>
                                                                </div>
                                                            </div>
                                                            <a onClick={(e) => this.completeSurvey(e)}>
                                                                <div className="button primary eu-mainsection-fleets-card-cta">
                                                                    <Trans>Complete Survey</Trans>
                                                                </div>
                                                            </a>
                                                        </a>
                                                    )
                                                :
                                                    null
                                            }
                                            {/* Invitation */}
                                            {
                                                this.props.sh_list.invitaion.length > 0 ?
                                                    this.props.sh_list.invitaion.map((stakeholder, index) =>
                                                        <a key={"invitaion_" + stakeholder.SH_ID} className="eu-mainsection-fleets-card">
                                                            <div className="eu-mainsection-fleets-card-section">
                                                                <div className="eu-mainsection-fleets-card-section-top">
                                                                    <div className="eu-mainsection-fleets-card-section-top-cars">
                                                                        <p className = 'primary'><Trans>Invited</Trans></p>
                                                                    </div>
                                                                </div>
                                                                <div className="eu-mainsection-fleets-card-section-mid">
                                                                    <img className = "eu-mainsection-fleets-card-logo" src={ stakeholder.image }/>
                                                                    <p className = "eu-mainsection-fleets-card-oem">{ stakeholder.Company }</p>
                                                                    <p className = "eu-mainsection-fleets-card-city">{ stakeholder.vmh_location }</p>
                                                                </div>
                                                            </div>
                                                            <a onClick={(e) => this.acceptInvitation(e, stakeholder.invitations[0].unique_code.Unique_Code)}>
                                                                <div className="button primary eu-mainsection-fleets-card-cta">
                                                                    <Trans>Accept Invitation</Trans>
                                                                </div>
                                                            </a>
                                                        </a>
                                                    )
                                                :
                                                    null
                                            }
                                            {/* Application */}
                                            {
                                                (shouldShowRequestAccessApplicationCard && this.props.sh_list.application.length > 0) ?
                                                    this.props.sh_list.application.map((stakeholder, index) =>
                                                        <a key={"request_" + stakeholder.SH_ID} className="eu-mainsection-fleets-card">
                                                            <div className="eu-mainsection-fleets-card-section">
                                                                <div className="eu-mainsection-fleets-card-section-top">
                                                                    {/* <div className="eu-mainsection-fleets-card-section-top-cars">
                                                                        
                                                                    </div> */}
                                                                </div>
                                                                <div className="eu-mainsection-fleets-card-section-mid">
                                                                    <img className = "eu-mainsection-fleets-card-logo" src={ stakeholder.image }/>
                                                                    <p className = "eu-mainsection-fleets-card-oem">{ stakeholder.Company }</p>
                                                                    <p className = "eu-mainsection-fleets-card-city">{ stakeholder.vmh_location }</p>
                                                                </div>
                                                            </div>
                                                            <a onClick={(e) => this.requestAccess(e, stakeholder.SH_ID)}>
                                                                <div className="button primary eu-mainsection-fleets-card-cta">
                                                                    <Trans>Get Access Now</Trans>
                                                                </div>
                                                            </a>
                                                        </a>
                                                    )
                                                :
                                                    null
                                            }
                                            {/*Pending*/}
                                            {
                                                this.props.sh_list.pending.length > 0 ?
                                                    this.props.sh_list.pending.map((stakeholder, index) =>
                                                        <a key={"pending_" + stakeholder.SH_ID} className="eu-mainsection-fleets-card fleets-card-pending">
                                                            <div className="eu-mainsection-fleets-card-section">
                                                                <div className="eu-mainsection-fleets-card-section-top">
                                                                    <div className="eu-mainsection-fleets-card-section-top-cars">
                                                                        <p className = 'yellow-warning'><Trans>Pending</Trans></p>
                                                                    </div>
                                                                </div>
                                                                <div className="eu-mainsection-fleets-card-section-mid">
                                                                    <img className = "eu-mainsection-fleets-card-logo" src={ stakeholder.image }/>
                                                                    <p className = "eu-mainsection-fleets-card-oem">{ stakeholder.Company }</p>
                                                                    <p className = "eu-mainsection-fleets-card-city">{ stakeholder.vmh_location }</p>
                                                                </div>
                                                            </div>
                                                            <p className = 'eu-mainsection-fleets-card-pendingmsg'>
                                                                <Trans>Your application is under review.</Trans>
                                                            </p>
                                                        </a>
                                                    )
                                                :
                                                    null
                                            }
                        
                                        </div>
                                    </div>
                                :
                                    null
                            }
                            {
                                this.props.sh_list.onhold.length > 0 ?
                                    <div className="eu-mainsection-fleets-category fleets-category-onhold">
                                        <h3 className = "eu-mainsection-fleets-category-title">On Hold</h3>
                                        <div className="line-break"></div>
                                        <div className="eu-mainsection-fleets-row">{/*On Hold*/}
                                            {
                                                this.props.sh_list.onhold.map((stakeholder, index) =>
                                                    <div className = "fleets-card-onhold">
                                                        <a key={"onhold_" + stakeholder.SH_ID} className="eu-mainsection-fleets-card">
                                                            <div className="eu-mainsection-fleets-card-section">
                                                                <div className="eu-mainsection-fleets-card-section-top">
                                                                    <div className="eu-mainsection-fleets-card-section-top-cars">
                                                                        <p className = 'black-lighter'><i class="fas fa-lock"></i><Trans>On hold</Trans></p>
                                                                    </div>
                                                                </div>
                                                                <div className="eu-mainsection-fleets-card-section-mid">
                                                                    <img className = "eu-mainsection-fleets-card-logo" src={ stakeholder.image }/>
                                                                    <p className = "eu-mainsection-fleets-card-oem">{ stakeholder.Company }</p>
                                                                    <p className = "eu-mainsection-fleets-card-city">{ stakeholder.vmh_location }</p>
                                                                </div>
                                                            </div>
                                                            <p className = 'eu-mainsection-fleets-card-onholdlock'>
                                                                <p className = 'fleets-card-onhold-info'><Trans>Contact</Trans> { stakeholder.contact_name } at { stakeholder.contact_email } <Trans>for more information</Trans>.</p>
                                                            </p>
                                                        </a>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                :
                                    null
                            }
                        </>
                }
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    endUser: store.endUser
});

export default connect(mapStateToProps)(EUFleets);